import React from 'react';

import { field } from '../types/Field';

const SearchDataContext = React.createContext({
    state: '',
    countyId: '',
    countyName: '',
    countySupportedPlatform: '',
    format: '',
    formatDescription: '',
    searchBy: '',
    searchByDescription: '',
    isReverse: true,
    coverageStart: '',
    coverageEnd: '',
    fields: [] as field[],
    searchMessage: '',
    setState: (state: string) => {},
    setCounty: (countyId: string, countyName: string, countySupportedPlatform: string) => {},
    setFormat: (format: string, formatDescription: string) => {},
    setSearchBy: (searchBy: string, searchByDescription: string) => {},
    setIsReverse: (isReverse: boolean) => {},
    setCoverage: (start: string, end: string) => {},
    setFields: (data: field[]) => {},
    setFieldValue: (abbreviation: string, newValue: string) => {},
    setSearchMessage: (message: string) => {},
});

export default SearchDataContext;
